import Vue from 'vue'
// import 'vant/lib/index.css';
import * as Integrations from '@sentry/integrations'
import App from './App'
import router from './router'
import store from './store'
import '@/assets/css/global.css'
import "cy_static/js/libs/rem.js";

import navHeader from '@/components/header'
import adModule from '@/components/adModule'
import proModule from '@/components/proModule'
import recModule from '@/components/recModule';
import pupWin from '@/components/pupWin';
import VueLazyLoad from 'vue-lazyload';
import VueTouch from 'vue-touch'
// import Vconsole from 'vconsole'
// new Vconsole()

import { Header, Swipe, SwipeItem, Button, Toast, Spinner, Progress, InfiniteScroll, MessageBox } from 'mint-ui';
import { Tab, Tabs, Sticky } from 'vant';

import 'mint-ui/lib/style.css'

Vue.config.productionTip = false
Vue.component(navHeader.name, navHeader)
Vue.component(adModule.name, adModule)
Vue.component(proModule.name, proModule)
Vue.component(recModule.name, recModule)
Vue.component(pupWin.name, pupWin)
Vue.use(InfiniteScroll);
Vue.use(VueLazyLoad);
Vue.use(Tab).use(Tabs).use(Sticky)
Vue.use(VueTouch, { name: 'v-touch' })



router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    } else {
        document.title = '畅由平台'
    }
    var fullPath = to.fullPath
    var nowUrl = spm.sliceBefore(document.URL, '#')
    var spmUrl = spm.addSpm(nowUrl, spm.getPageCode()) + '#' + fullPath
    var toPathName = to.name;
    // to.meta.showTab ? showTab() : hideTab();
    switch (toPathName) {
        case 'Homenew':
            // spm.setPageCode('102082', '首页');
            spm.setPageCode('102211', { title: "首页", pageName: "畅由公众号首页", dept: "产品" });
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'Discover':
            spm.setPageCode('100450', '福利社')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'Dissearch':
            spm.setPageCode('101205', '商品搜索')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'Detail':
            spm.setPageCode('101206', '商品详情')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'Center':
            spm.setPageCode('101207', '返利中心')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'Jfpay':
            spm.setPageCode('100453', '钱包')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'article':
            spm.setPageCode('102102', '')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'Member':
            spm.setPageCode('102085', { title: "我的", pageName: "我的", dept: "产品" });
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'order':
            spm.setPageCode('100456', '订单列表')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'DiscoverList':
            spm.setPageCode('100485', '福利')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'cymall':
            // spm.setPageCode('100450', {title:"商城", pageName:"新商城页", dept:"产品"});
            spm.setPageCode('102054', { title: "商城", pageName: "新商城页", dept: "产品" });
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'pointsmall':
            spm.setPageCode('102113', '花积分')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'Search':
            spm.setPageCode('100783', '搜索')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'GetLimt':
            spm.setPageCode('101941', '限时抢购')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'Other':
            spm.setPageCode('102097', '其他')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'groupHome':
            spm.setPageCode('102212', '畅由拼团')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'groupSuccess':
            spm.setPageCode('102219', '支付成功')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'myGroup':
            spm.setPageCode('102213', '我的拼团')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'groupDetails':
            spm.setPageCode('102214', '拼团详情页')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'pinTuanOrder':
            spm.setPageCode('102233', '我的订单')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'pageSearch':
            // spm.setPageCode('102478', '搜索')
            spm.setPageCode('102478', { title: "搜索", pageName: "搜索页", dept: "产品" });
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        case 'pageSearch1212':
            spm.setPageCode('102478', '搜索')
            spm.push(['_trackPageview', spmUrl])
            next();
            break
        // case 'hjf':
        //     spm.setPageCode('102554','畅由积分当钱花')
        //     spm.push(['_trackPageview'])
        //     next();
        //     break
        case 'invite':
            spm.setPageCode('102683', '畅由果园')
            spm.push(['_trackPageview'])
            next();
            break
        case 'myActivity':
            spm.setPageCode('102598', '我的')
            spm.push(['_trackPageview'])
            next();
            break
        default:
            next()
    }
})

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})
